import { useState, useEffect } from 'react';

const useCountdown = (seconds: number, onEnd: () => void): number => {
  const [counter, setCounter] = useState<number>(seconds);

  useEffect(() => {
    let timer: ReturnType<typeof setInterval> | undefined;
    if (counter > 0) {
      timer = setInterval(() => {
        setCounter(c => c - 1);
      }, 1000);
    } else {
      onEnd();
    }
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [counter, onEnd]);

  return counter;
};

export { useCountdown };
